import { Link, useRouteError } from "react-router";
import { Button, EmptyState, Page } from "@/shared/ui";

/**
 * 页面崩溃时给玩家一句人话和两个出口（刷新、回到地图）。报错原文（常是英文的 JS 报错）只记进控制台日志，页面上、读屏属性里都不出现：
 * 用户 10-09 定稿（X-09／U-26）玩家端不显示技术代码，也不做“展开看详情”的折叠区，要查只在运营后台查（原来收起的那一块已拿掉）。
 */
export const ROUTE_ERROR_HINT = "刷新一下试试；还不行的话，先回地图。";

export function RouteErrorPage() {
  const error = useRouteError();
  console.error("[petsoul] route error", error);
  return (
    <Page bare>
      <div className="ps-state ps-state--error" role="alert" style={{ marginTop: "20vh" }}>
        <h1 className="ps-state__title">这一页没能打开</h1>
        <div className="ps-muted">{ROUTE_ERROR_HINT}</div>
        <div className="ps-row" style={{ justifyContent: "center" }}>
          <Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>
            刷新
          </Button>
          <Link className="ps-btn ps-btn--secondary" to="/map">
            回到地图
          </Link>
        </div>
      </div>
    </Page>
  );
}

/** 找不到的地址：页面固定文案“这里还没有路”（KEEP-G03，K-18 定为页面文案、保留），给回到地图的出口。 */
export function NotFoundPage() {
  return (
    <Page>
      <div style={{ marginTop: "18vh" }}>
        <EmptyState icon="compass" title="这里还没有路" pageHeading action={<Link className="ps-btn ps-btn--primary" to="/map">回到地图</Link>}>
          地址可能写错了，或者这个地方还在建设。
        </EmptyState>
      </div>
    </Page>
  );
}
